import { BlockWrapper, defineBlock } from '@smartfire/js-block-engine';
import style from './block.module.scss';

function Footer({ menu }) {
    return (
        <BlockWrapper.Footer className={style.footer}>
            {menu &&
                Object.values(menu).map((item) => (
                    <a key={item.ID} rel="noopener noreferrer" target="_blank" className={style.item} href={item.url}>
                        {item.title}
                    </a>
                ))}
        </BlockWrapper.Footer>
    );
}

export default defineBlock({
    Block: Footer,
    setup: {
        title: 'Footer',
    },
    smartProps: {},
});
